import { render } from "./Latest.vue?vue&type=template&id=717280f3&scoped=true"
import script from "./latest.js?vue&type=script&lang=js&external"
export * from "./latest.js?vue&type=script&lang=js&external"

import "./Latest.vue?vue&type=style&index=0&id=717280f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717280f3"]])

export default __exports__